import * as React from 'react';

function SvgVideocam(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fill: "currentColor", d: "M20.667 17.35c-.187 0-.372-.04-.542-.116a.652.652 0 01-.113-.064l-3.446-2.426a1.335 1.335 0 01-.566-1.09v-3.308a1.334 1.334 0 01.566-1.09l3.446-2.426a.654.654 0 01.113-.064A1.333 1.333 0 0122 7.984v8.032a1.333 1.333 0 01-1.333 1.333zM12.5 18H4.833A2.836 2.836 0 012 15.167V8.833A2.836 2.836 0 014.833 6h7.687a2.817 2.817 0 012.813 2.813v6.354A2.836 2.836 0 0112.5 18z" })));
}

export default SvgVideocam;
